import wx from "weixin-js-sdk";
const config = {
  baseConfig: {

  },
  pageConfig: {
    //员工端 客户列表筛选
    customerFilterOptions: [{
        title: '客户类型',
        show: true,
        value: 1,
        children: [{
            text: '全部',
            value: 0,
            selected: true,
            show: true
          },
          {
            text: '代账客户',
            value: 1,
            selected: false,
            show: true
          },
          {
            text: '工商客户',
            value: 2,
            selected: false,
            show: true
          },
          {
            text: '代账+工商',
            value: 3,
            selected: false,
            show: false
          },
        ]
      },
      {
        title: '客户状态',
        show: true,
        value: 2,
        children: [{
            text: '全部',
            value: 0,
            selected: true,
            show: true
          },
          // {
          //   text: '本月到期',
          //   value: 1,
          //   selected: false,
          //   show: false
          // },
          {
            text: '下月到期',
            value: 6,
            selected: false,
            show: false
          },
          {
            text: '已到期',
            value: 2,
            selected: false,
            show: false
          },
          {
            text: '欠费',
            value: 3,
            selected: false,
            show: true
          },
          {
            text: '缺票',
            value: 4,
            selected: false,
            show: false
          },
          {
            text: '停止服务',
            value: 5,
            selected: false,
            show: false
          },
        ]
      },
      {
        title: '服务状态',
        show: false,
        value: 3,
        children: [{
            text: '全部',
            value: 0,
            selected: true,
            show: true
          },
          {
            text: '进行中',
            value: 1,
            selected: false,
            show: true
          },
          {
            text: '已完成',
            value: 2,
            selected: false,
            show: true
          },
        ]
      }
    ],
    //外勤筛选
    fieldAssignmentFilterOptions: [{
        title: '任务状态',
        show: true,
        value: 1,
        children: [{
            text: '全部',
            value: -1,
            selected: false,
            show: true
          },
          {
            text: '进行中',
            value: 0,
            selected: true,
            show: true
          },
          {
            text: '已完成',
            value: 1,
            selected: false,
            show: true
          },
          {
            text: '已关闭',
            value: 3,
            selected: false,
            show: true
          },
          {
            text: '已取消',
            value: 2,
            selected: false,
            show: true
          },
        ]
      },
      {
        title: '任务指派',
        show: true,
        value: 2,
        children: [{
            text: '全部',
            value: 1,
            selected: false,
            show: true
          },
          {
            text: '指派给我的',
            value: 2,
            selected: true,
            show: true
          },
        ]
      },
      {
        title: '任务类型',
        show: true,
        value: 3,
        children: [{
          text: '全部',
          value: -1,
          selected: true,
          show: true
        }, ]
      }
    ],
    //续费筛选代账
    wxRenewFilterOptions_acct: [{
        title: '状态',
        show: true,
        value: 1,
        children: [{
            text: '欠费',
            value: 3,
            selected: true,
            show: true
          },
          {
            text: '正常',
            value: 2,
            selected: false,
            show: true
          },
          {
            text: '预收',
            value: 1,
            selected: false,
            show: true
          }
        ]
      },
      {
        title: '服务项目',
        show: true,
        value: 2,
        children: [{
            text: '全部',
            value: 0,
            selected: true,
            show: true
          },
          {
            text: '记账+报税',
            value: 3,
            selected: false,
            show: true
          },
          {
            text: '记账',
            value: 1,
            selected: false,
            show: true
          },
          {
            text: '报税',
            value: 2,
            selected: false,
            show: true
          }
        ]
      }
    ],
    //续费筛选工商
    wxRenewFilterOptions_buss: [{
        title: '收款状态',
        show: true,
        value: 3,
        children: [{
            text: '全部',
            value: 0,
            selected: false,
            show: true
          },
          {
            text: '正常',
            value: 1,
            selected: false,
            show: true
          },
          {
            text: '欠费',
            value: 2,
            selected: true,
            show: true
          }
        ]
      },
      {
        title: '服务类型',
        show: true,
        value: 4,
        children: [{
          text: '全部',
          value: 0,
          selected: true,
          show: true
        }]
      }
    ],
    //续费筛选新增的收款类别
    wxRenewTypeFilterOptions: [{
      title: '收款类别',
      show: true,
      value: 5,
      children: [{
          text: '代账服务',
          value: 1,
          selected: true,
          show: true
        },
        {
          text: '工商服务',
          value: 2,
          selected: false,
          show: true
        }
      ]
    }],
    //工商服务
    businessFilterOptions: [{
        title: '服务状态',
        show: true,
        value: 1,
        children: [{
            text: '全部',
            value: 0,
            selected: true,
            show: true
          },
          {
            text: '未开始',
            value: 4,
            selected: false,
            show: true
          },
          {
            text: '进行中',
            value: 1,
            selected: false,
            show: true
          },
          {
            text: '已超期',
            value: 3,
            selected: false,
            show: true
          },
          {
            text: '已完成',
            value: 2,
            selected: false,
            show: true
          },
        ]
      },
      {
        title: '任务指派',
        show: true,
        value: 2,
        children: [{
            text: '全部',
            value: 0,
            selected: true,
            show: true
          },
          {
            text: '指派给我的',
            value: 1,
            selected: false,
            show: true
          },
        ]
      },
      {
        title: '服务类型',
        show: true,
        value: 3,
        children: [{
          text: '全部',
          value: -1,
          selected: true,
          show: true
        }, ]
      }
    ],
    monthsPickerOptions: [{
        month: 1,
        selected: false
      },
      {
        month: 2,
        selected: false
      },
      {
        month: 3,
        selected: false
      },
      {
        month: 4,
        selected: false
      },
      {
        month: 5,
        selected: false
      },
      {
        month: 6,
        selected: false
      },
      {
        month: 7,
        selected: false
      },
      {
        month: 8,
        selected: false
      },
      {
        month: 9,
        selected: false
      },
      {
        month: 10,
        selected: false
      },
      {
        month: 11,
        selected: false
      },
      {
        month: 12,
        selected: false
      }
    ],
  },
  //公用方法
  func: {
    //深克隆
    clone: function (obj) {
      if (obj == null) return obj;
      var newObj = {};
      if (obj instanceof Array) {
        newObj = [];
      }
      for (var key in obj) {
        var val = obj[key];
        newObj[key] = typeof val === 'object' ? config.func.clone(val) : val;
      }
      return newObj;
    },
    //判断区分小程序或公众号环境
    getRnv: function() {
      const ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
        wx.miniProgram.getEnv(res => {
          if (res.miniprogram) {
            return "miniprogram";
          } else {
            return "public";
          }
        });
      } else {
        return "public";
      }
    }
  },
}
export default config